import React from "react";
import { motion } from "framer-motion";
import WhyChooseUs from "../UI/WhyChooseUs";

const WhyChooseUsStructure = () => {
  const features = [
    {
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FStructure%2Fwhy_choose_us%2FRealistic_3D_Visualization.png?alt=media&token=b10e3b7e-9fd1-48c8-bce3-d2c9a8e60b3c",
      title: "Realistic 3D Visualization",
      description: "Bring ideas to life with highly accurate 3D renderings, showcasing the project with stunning realism.",
    },
    {
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FStructure%2Fwhy_choose_us%2FCost_Effective_Revisions.png?alt=media&token=56b5b421-240a-483c-a87d-dcf19d860834",
      title: "Cost-Effective Revisions",
      description:
        "Get unlimited design modifications without breaking the budget, ensuring optimal project outcomes.",
    },
 
    {
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FStructure%2Fwhy_choose_us%2FInteractive_Virtual_Tour.png?alt=media&token=27cbc544-3c80-4105-b0b4-92e6363b8a25",
      title: "Interactive Virtual Tour",
      description: "Immerse yourself in a lifelike virtual tour, allowing real-time exploration of spaces before construction begins.",
    },
    {
      icon:"https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FStructure%2Fwhy_choose_us%2FDetailed_Interiors_and_Exteriors.png?alt=media&token=2658ccd2-f780-4b8d-b118-af3fa7273fc0",
      title: "Detailed Interiors & Exteriors",
      description: "Experience well-planned, high-quality interior and exterior designs with meticulous attention to detail.",
    },
    {
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FStructure%2Fwhy_choose_us%2FMarketing_and_Client_Presentations.png?alt=media&token=8e39f84a-3eb8-4c8a-afd4-4a4761a6b61b",
      title: "Marketing & Client Presentations",
      description: "Enhance your project’s appeal with compelling visual presentations for better client engagement and sales.",
    },
 
  ];

  return (
   <>
   <WhyChooseUs features={features}/>
   </>
  );
};

export default WhyChooseUsStructure;
